module.exports = __webpack_public_path__ + "img/objects.df954e70.svg";